export function roleLabel(role) {
  if (role === "manager") return "Area Manager";
  if (role === "admin") return "Admin / Supervisor";
  if (role === "support") return "Call Center";
  return "Sales Executive";
}

export function ownerLabel(users, userId) {
  const owner = users.find((user) => user.id === userId);
  if (!owner) return "Unassigned";
  return owner.active === false ? `${owner.name} (inactive)` : owner.name;
}

export function customerName(customers, customerId) {
  if (customerId === "office") return "Office";
  return customers.find((customer) => customer.id === customerId)?.name ?? customerId ?? "Unknown";
}

export function renderGps(activity) {
  if (activity.type !== "visit") return "-";
  if (!activity.latitude || !activity.longitude) return "Not captured";
  return `${Number(activity.latitude).toFixed(4)}, ${Number(activity.longitude).toFixed(4)}`;
}

export function formatLatLng(point) {
  if (!point?.latitude || !point?.longitude) return "-";
  return `${Number(point.latitude).toFixed(4)}, ${Number(point.longitude).toFixed(4)}`;
}

export function sortNewest(a, b) {
  return String(b.date || b.createdAt).localeCompare(String(a.date || a.createdAt));
}

export function formatDate(value) {
  if (!value) return "-";
  return new Intl.DateTimeFormat("en-IN", { day: "2-digit", month: "short", year: "numeric" }).format(parseDisplayDate(value));
}

export function formatDateTime(value) {
  if (!value) return "-";
  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
}

export function formatTime(value) {
  if (!value) return "-";
  return new Intl.DateTimeFormat("en-IN", { hour: "2-digit", minute: "2-digit" }).format(new Date(value));
}

export function formatDuration(value) {
  const minutes = Math.round(Number(value || 0));
  if (!minutes) return "-";
  const hours = Math.floor(minutes / 60);
  const remaining = minutes % 60;
  if (!hours) return `${remaining} min`;
  return remaining ? `${hours} hr ${remaining} min` : `${hours} hr`;
}

export function slug(text) {
  return String(text || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export function toOption(item) {
  return { value: item.id, label: item.name };
}

export function currency(value) {
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Number(value || 0));
}

function parseDisplayDate(value) {
  if (/^\d{4}-\d{2}-\d{2}$/.test(String(value))) {
    const [year, month, day] = String(value).split("-").map(Number);
    return new Date(year, month - 1, day);
  }
  return new Date(value);
}
